import { config } from "../../config";
import { HttpServices } from "../../Helper";

export const GetPaymentFormAPI = async ({ contactId, memberId }) => {
  const queryList = [];

  if (contactId) queryList.push(`contactId=${contactId}`);
  if (memberId) queryList.push(`memberId=${memberId}`);

  const result = await HttpServices.get(
    `${config.server_address}/CrmDfm/Payment/getPaymentForm?${queryList.join(
      "&"
    )}`
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const UpdatePaymentFormAPI = async (body) => {
  const result = await HttpServices.put(
    `${config.server_address}/CrmDfm/Payment/updatePaymentForm`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response.data);
  return result;
};
